export default "__VITE_ASSET__Sjv3TuL$__"